import { graphql, PageProps } from "gatsby";
import Seo from "@components/Seo";
import React from "react";
import Main from "@components/Layout/Main";
import { FlexBox } from "@styles";
import RichText from "@components/RichText";
import styled from "styled-components";
import CategoryFlatList from "@components/FlatList/CategoryFlatList";

const Iframe = styled.iframe`
  width: 100%;
  height: max(50vw);
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 16rem;
  column-gap: 3rem;

  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const Video = ({ data: { videos } }: PageProps<Queries.VideoPageQuery>) => {
  const embedUrl = videos?.vimeo_video_url;

  const video = embedUrl ? embedUrl.slice(18) : videos?.video?.embed ?? "";
  const title = videos?.translations?.[0]?.title ?? "";
  const description = videos?.translations?.[0]?.description;
  return (
    <Main title={title} goBack={{ to: "/resources?resource-type=video", label: "Browse All Videos" }}>
      <Grid>
        <FlexBox direction="column">
          <Iframe
            src={ `https://player.vimeo.com/video/${video}/?h=6e7f290d27&portrait=0&byline=0&title=0`}
            title={title}
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            frameBorder="0"
            style={{ padding: 0, display: "initial" }}
            allowFullScreen
          />
          <RichText body={description} template="prose" />
        </FlexBox>
      </Grid>

      <CategoryFlatList
        currArticleId={videos?.id ?? null}
        categories={videos?.category.map((x: any) => ({
          name: x.name,
          product_content: x.product_content as Queries.product_content[],
        }))}
      />
    </Main>
  );
};

export default Video;

export const Head = ({ data: { videos } }: { data: Queries.VideoPageQuery }) => 
  <Seo title={videos?.translations?.[0]?.title ?? "Video"}
  description={videos?.translations?.[0]?.description ?? undefined}
  
  />;

export const query = graphql`
  query VideoPage($slug: String) {
    videos(slug: { eq: $slug }) {
      id
      vimeo_video_url

      translations {
        description
        title
      }
      video {
        embed
      }
      category {
        name
        product_content {
          ...ProductContent
        }
      }
    }
  }
`;
